/// Checking if production - if so add analytics
const hostname = window.location.hostname;
const localhost = hostname === 'localhost';
const env = (function () {
    if (localhost) return 'development';
    return 'production';
})();
module.exports = {
    baseUrl: env == 'development' ? process.env.VUE_APP_URL : process.env.VUE_APP_URL_LIVE,
    resellerTypes: [
        {
            label: 'Installers',
            value: 'installer'
        },
        {
            label: 'Retailers',
            value: 'retailer'
        }
    ],
    regions: [
        'Eastern Cape',
        'Free State',
        'Gauteng',
        'KwaZulu-Natal',
        'Limpopo',
        'Mpumalanga',
        'Northern Cape',
        'North West',
        'Western Cape',
        'Gabarone'
    ],
    gasModels: [
        '30cm – 2 Burner Hob',
        'Dewhot 20L Fan Forced (includes flexi flue)',
        'Dewhot 16L (SS)',
        '16lt ecodew',
        'Dewhot 16L Constant Temperature',
        'Dewhot 12L (SS)',
        '12lt ecodew white',
        '12L CT Natural Gas (incl flexi flue)',
        '12lt Constant Temperature (incl flexi flue)',
        'Dewhot 12L Low Pressure (incl flexi flue)',
        'Dewhot 10L (SS)',
        '8lt ecodew white',
        'Dewhot 8L Natural Gas',
        'Dewhot 8L (SS)',
        'Dewhot 6L (SS)',
        '5lt Low Pressure',
        '5lt EcoDew – Type B',
        '5lt ecodew white (B)(includes flexi flue)',
        '60cm Stainless  Steel Hob',
        'Oven And Hob Combo'
    ],
    gasModelSkus: {
        '30cm – 2 Burner Hob': {sku: '2BSS', sn_length: 3},
        'Dewhot 20L Fan Forced (includes flexi flue)': {sku: 'RS20DH', sn_length: 6},
        'Dewhot 16L (SS)': {sku: 'JSD16', sn_length: 3},
        '16lt ecodew': {sku: 'NDS16DH', sn_length: 6},
        'Dewhot 16L Constant Temperature': {sku: 'NDCT16DH', sn_length: 6},
        'Dewhot 12L (SS)': {sku: 'JSD12', sn_length: 3},
        '12lt ecodew white': {sku: 'NDS12DH', sn_length: 6},
        '12L CT Natural Gas (incl flexi flue)': {sku: 'NDCT12DH', sn_length: 6},
        '12lt Constant Temperature (incl flexi flue)': {sku: 'NDCT12DH', sn_length: 6},
        'Dewhot 12L Low Pressure (incl flexi flue)': {sku: 'LPDH12', sn_length: 6},
        'Dewhot 10L (SS)': {sku: 'JSD10', sn_length: 3},
        '8lt ecodew white': {sku: 'NDS8DH', sn_length: 6}, //
        'Dewhot 8L Natural Gas': {sku: 'NDS8DH', sn_length: 6},
        'Dewhot 8L (SS)': {sku: 'JSD8', sn_length: 3},
        'Dewhot 6L (SS)': {sku: 'JSD6', sn_length: 3},
        '5lt Low Pressure': {sku: 'LPDH5A', sn_length: 6},
        '5lt EcoDew – Type B': {sku: 'LPDH5B', sn_length: 6},
        '5lt ecodew white (B)(includes flexi flue)': {sku: 'LPDH5B', sn_length: 6},
        '60cm Stainless  Steel Hob': {sku: '4BHSS', sn_length: 6},
        'Oven And Hob Combo': {sku: 'DHC2B', sn_length: 3}
    }
};
